(function () {
  'use strict';
  document.documentElement.className = document.documentElement.className.replace('no-js', 'js');

  function each(nodes, callback) {
    Array.prototype.forEach.call(nodes || [], callback);
  }

  function ready(callback) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', callback);
    else callback();
  }

  ready(function () {
    var toggle = document.querySelector('[data-menu-toggle]');
    var menu = document.querySelector('.header__nav');

    function setMenu(open, restoreFocus) {
      document.body.classList.toggle('menu-open', open);
      if (toggle) {
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        toggle.setAttribute('aria-label', open ? 'Menüyü kapat' : 'Menüyü aç');
      }
      if (open && menu) {
        var firstLink = menu.querySelector('a');
        if (firstLink) firstLink.focus();
      } else if (restoreFocus && toggle) {
        toggle.focus();
      }
    }

    if (toggle) {
      toggle.addEventListener('click', function () {
        setMenu(!document.body.classList.contains('menu-open'), false);
      });
    }
    if (menu) {
      each(menu.querySelectorAll('a'), function (link) {
        link.addEventListener('click', function () { setMenu(false, false); });
      });
    }
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && document.body.classList.contains('menu-open')) setMenu(false, true);
    });

    each(document.querySelectorAll('[data-qty-minus]'), function (button) {
      button.addEventListener('click', function () {
        var input = button.parentNode.querySelector('input');
        input.value = Math.max(1, parseInt(input.value || '1', 10) - 1);
      });
    });
    each(document.querySelectorAll('[data-qty-plus]'), function (button) {
      button.addEventListener('click', function () {
        var input = button.parentNode.querySelector('input');
        input.value = Math.max(1, parseInt(input.value || '1', 10) + 1);
      });
    });

    each(document.querySelectorAll('[data-sticky-submit]'), function (button) {
      button.addEventListener('click', function () {
        var form = document.querySelector('[data-product-form]');
        if (form && form.requestSubmit) form.requestSubmit();
        else if (form) form.submit();
      });
    });

    each(document.querySelectorAll('[data-product-form][data-direct-checkout="true"]'), function (form) {
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        var button = form.querySelector('[type="submit"]');
        if (button) { button.disabled = true; button.setAttribute('aria-busy', 'true'); }
        var request = new XMLHttpRequest();
        request.open('POST', '/cart/add.js', true);
        request.setRequestHeader('Accept', 'application/json');
        request.onreadystatechange = function () {
          if (request.readyState !== 4) return;
          if (request.status >= 200 && request.status < 300) window.location.href = '/checkout';
          else form.submit();
        };
        request.onerror = function () { form.submit(); };
        request.send(new FormData(form));
      });
    });

    each(document.querySelectorAll('[data-product-gallery]'), function (gallery) {
      var progress = document.querySelector('[data-gallery-progress]');
      function update() {
        if (!progress) return;
        var max = Math.max(1, gallery.scrollWidth - gallery.clientWidth);
        progress.style.width = Math.max(15, Math.min(100, (gallery.scrollLeft / max) * 100)) + '%';
      }
      gallery.addEventListener('scroll', update);
      update();
    });

    each(document.querySelectorAll('[data-video-open]'), function (button) {
      button.addEventListener('click', function () {
        var dialog = document.getElementById(button.getAttribute('data-video-id'));
        if (dialog && dialog.showModal) dialog.showModal();
      });
    });
    each(document.querySelectorAll('[data-video-close]'), function (button) {
      button.addEventListener('click', function () {
        var dialog = button.closest ? button.closest('dialog') : button.parentNode;
        if (dialog) { var video = dialog.querySelector('video'); if (video) video.pause(); dialog.close(); }
      });
    });

    each(document.querySelectorAll('.product-accordions details'), function (details) {
      details.addEventListener('toggle', function () {
        if (!details.open) return;
        window.setTimeout(function () {
          var rect = details.getBoundingClientRect();
          if (rect.top < 110 || rect.bottom > window.innerHeight) {
            details.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        }, 80);
      });
    });

    function initMarketplaceReviews(root) {
      each((root || document).querySelectorAll('[data-marketplace-reviews]'), function (section) {
        var reviews = window.SheovationMarketplaceReviews || [];
        var list = section.querySelector('[data-reviews-list]');
        var controls = section.querySelector('[data-review-pagination]');
        if (!list || !controls || !reviews.length || list.getAttribute('data-reviews-ready') === 'true') return;
        list.setAttribute('data-reviews-ready', 'true');

        function escapeHtml(value) {
          return String(value || '').replace(/[&<>\"']/g, function (character) {
            return {'&':'&amp;','<':'&lt;','>':'&gt;','\"':'&quot;',"'":'&#039;'}[character];
          });
        }
        function stars(rating) {
          var output = '';
          for (var star = 1; star <= 5; star += 1) output += star <= rating ? '★' : '☆';
          return output;
        }

        var priorityIndexes = [3, 6, 41, 0, 43];
        var orderedReviews = [];
        each(priorityIndexes, function (index) { if (reviews[index]) orderedReviews.push(reviews[index]); });
        each(reviews, function (review, index) { if (priorityIndexes.indexOf(index) === -1) orderedReviews.push(review); });
        var isMobile = window.matchMedia && window.matchMedia('(max-width: 700px)').matches;
        var perPage = isMobile ? 3 : parseInt(section.getAttribute('data-reviews-per-page') || '5', 10);
        var visibleCount = list.querySelectorAll('[data-review-item]').length;
        var status = document.createElement('span');
        var loadMore = document.createElement('button');
        status.className = 'review-load-more__status';
        loadMore.className = 'review-load-more__button';
        loadMore.type = 'button';
        loadMore.textContent = 'Daha fazla yorum göster';
        controls.appendChild(status);
        controls.appendChild(loadMore);

        function appendReviews() {
          var nextReviews = orderedReviews.slice(visibleCount, visibleCount + perPage);
          var markup = '';
          each(nextReviews, function (review) {
            var needsReadMore = review.text.length > (isMobile ? 170 : 280);
            markup += '<article class="review-row" data-review-item>' +
              '<div class="review-identity"><strong>' + escapeHtml(review.author) + '</strong></div>' +
              '<time class="review-date">' + escapeHtml(review.date) + '</time>' +
              '<div class="review-rating"><span class="stars" aria-label="' + escapeHtml(review.rating) + ' yıldız">' + stars(review.rating) + '</span></div>' +
              '<span class="verified-badge">Pazar yeri yorumu</span>' +
              '<div class="review-content"><p class="review-text' + (needsReadMore ? ' is-collapsed' : '') + '">' + escapeHtml(review.text) + '</p>' +
              (needsReadMore ? '<button class="review-read-more" type="button" data-review-read-more aria-expanded="false">Devamını oku</button>' : '') + '</div>' +
              '<span class="review-source">Kaynak: ' + escapeHtml(review.source) + '</span></article>';
          });
          list.insertAdjacentHTML('beforeend', markup);
          visibleCount += nextReviews.length;
          status.textContent = visibleCount + ' / ' + orderedReviews.length + ' yorum gösteriliyor';
          if (visibleCount >= orderedReviews.length) controls.classList.add('is-complete');
          each(list.querySelectorAll('[data-review-read-more]:not([data-bound])'), function (button) {
            button.setAttribute('data-bound', 'true');
            button.addEventListener('click', function () {
              var text = button.parentNode.querySelector('.review-text');
              var expanded = button.getAttribute('aria-expanded') === 'true';
              button.setAttribute('aria-expanded', expanded ? 'false' : 'true');
              button.textContent = expanded ? 'Devamını oku' : 'Daha az göster';
              text.classList.toggle('is-collapsed', expanded);
            });
          });
        }

        loadMore.addEventListener('click', appendReviews);
        if (visibleCount === 0) {
          appendReviews();
        } else {
          status.textContent = visibleCount + ' / ' + orderedReviews.length + ' yorum gösteriliyor';
          if (visibleCount >= orderedReviews.length) controls.classList.add('is-complete');
        }
      });
    }

    function requestMarketplaceReviews(root) {
      var scope = root || document;
      var sections = scope.querySelectorAll('[data-marketplace-reviews]');
      if (!sections.length) return;

      function loadData() {
        if (window.SheovationMarketplaceReviews) {
          initMarketplaceReviews(document);
          return;
        }
        if (!window.SheovationReviewsAssetUrl || document.querySelector('script[data-sheovation-reviews]')) return;
        var script = document.createElement('script');
        script.src = window.SheovationReviewsAssetUrl;
        script.defer = true;
        script.setAttribute('data-sheovation-reviews', 'true');
        script.addEventListener('load', function () { initMarketplaceReviews(document); });
        document.head.appendChild(script);
      }

      if (!('IntersectionObserver' in window)) {
        window.setTimeout(loadData, 1500);
        return;
      }

      var observer = new IntersectionObserver(function (entries) {
        each(entries, function (entry) {
          if (!entry.isIntersecting) return;
          observer.disconnect();
          loadData();
        });
      }, { rootMargin: '900px 0px' });

      each(sections, function (section) {
        if (section.getAttribute('data-reviews-observed') === 'true') return;
        section.setAttribute('data-reviews-observed', 'true');
        observer.observe(section);
      });
    }

    requestMarketplaceReviews(document);
    document.addEventListener('shopify:section:load', function (event) {
      requestMarketplaceReviews(event.target);
      initMarketplaceReviews(event.target);
    });
  });
}());
